import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Select from "react-select";
import EquipmentTable from "./EquipmentTable";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import MobileUnitApi from "../../../../api/MobileUnitApi";
import Cookies from "js-cookie";

export default function CreateTab({ refreshEquipment }) {
    const portalToken = Cookies.get("portalSession");
    const { selectedMobileUnit } = useSelector((state) => state.equipmentsPortfolio);

    const [equipmentVals, setEquipmentVals] = useState({
        equipmentName: "",
        sf: 1.15,
        freq: 60,
    });
    const [showModal, setShowModal] = useState(false);
    const [otp, setOtp] = useState("");
    const [verifyToken, setVerifyToken] = useState("");

    const [alert, setAlert] = useState({
        color: "primary",
        text: "",
        show: false,
    });

    const [disableModal, setDisableModal] = useState(false);

    useEffect(() => {
        clearEqVals();
        if (selectedMobileUnit == null) {
            setAlert({
                color: "primary",
                text: "Select a Mobile Unit to Get Started",
                show: true,
            });
            return;
        }
        if (selectedMobileUnit.location_node_id != null) {
            setAlert({
                color: "primary",
                text: "The Current Location Must Be Deactivated Before Creating a New One",
                show: true,
            });
            return;
        }
    }, [selectedMobileUnit]);

    const isOtpValid = (val) => {
        const re = /[^0-9]/;
        if (re.test(val)) return false;
        if (val.length > 8) return false;
        return true;
    };

    const onOtpUpdate = (event) => {
        const val = event.target.value;
        const valid = isOtpValid(val);
        if (valid) {
            setOtp(val);
        }
        return;
    };

    const onSubmit = () => {
        createLocation();
    };

    const onConfirm = () => {
        setDisableModal(true);
        MobileUnitApi.verifyCreate(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            verifyToken,
            otp,
        )
            .then((resp) => {
                if (resp.status == 200) {
                    setAlert({
                        color: "success",
                        text: "Create Successful. Analytics Will Update In a Few Minutes.",
                        show: true,
                    });
                    refreshEquipment();
                } else {
                    const text = resp.data.errorMessage ?? "Error During Creation. Try Again Later";
                    setAlert({
                        color: "danger",
                        text: text,
                        show: true,
                    });
                }
                setDisableModal(false);
                setOtp("");
                setShowModal(false);
                setVerifyToken("");
            })
            .catch((err) => {
                const text = err.response?.data?.errorMessage ?? "Error During Creation. Try Again Later";
                setAlert({
                    color: "danger",
                    text: text,
                    show: true,
                });
                setDisableModal(false);
                setOtp("");
                setShowModal(false);
                setVerifyToken("");
            });
    };

    const onCancel = () => {
        setShowModal(false);
        setOtp("");
        setVerifyToken("");
    };

    const clearEqVals = () => {
        setEquipmentVals({
            equipmentName: "",
            voltage: "",
            current: "",
            sf: "",
            freq: "",
            rpm: "",
            hp: "",
            poles: "",
            rotorBars: "",
            equipmentType: null,
            starter: null,
            vTapLocation: null,
            CTLocation: null,
        });
    };

    const createLocation = () => {
        setDisableModal(false);
        setOtp("");
        setShowModal(true);
        MobileUnitApi.createLocation(
            portalToken,
            selectedMobileUnit.customer_id,
            selectedMobileUnit.facility_id,
            selectedMobileUnit.node_sn,
            equipmentVals?.equipmentName,
            equipmentVals?.voltage,
            equipmentVals?.current,
            equipmentVals?.sf,
            equipmentVals?.freq,
            equipmentVals?.rpm,
            equipmentVals?.hp,
            equipmentVals?.poles,
            equipmentVals?.rotorBars,
            equipmentVals?.equipmentType?.value,
            equipmentVals?.starter?.value,
            equipmentVals?.vTapLocation?.value,
            equipmentVals?.CTLocation?.value,
        )
            .then((resp) => {
                if (resp.status == 200 && resp.data.data?.token) {
                    setVerifyToken(resp.data.data.token);
                } else {
                    const text = resp.data.errorMessage ?? "Error During Creation. Try Again Later";
                    setAlert({
                        color: "danger",
                        text: text,
                        show: true,
                    });
                    setShowModal(false);
                }
            })
            .catch((err) => {
                const text = err.response?.data?.errorMessage ?? "Error During Creation. Try Again Later";
                setAlert({
                    color: "danger",
                    text: text,
                    show: true,
                });
                setDisableModal(false);
                setOtp("");
                setShowModal(false);
                setVerifyToken("");
            });
    };

    const isActiveLocation = selectedMobileUnit?.location_node_id != null;

    const isDisabled = selectedMobileUnit == null || isActiveLocation;
    return (
        <div>
            <br />
            <Col>
                <Alert
                    variant={alert.color}
                    show={alert.show}
                    dismissible
                    onClose={() => setAlert({ color: "", text: "", show: false })}
                >
                    {alert.text}
                </Alert>
            </Col>
            <EquipmentTable props={equipmentVals} setProps={setEquipmentVals} disabled={isDisabled}></EquipmentTable>
            <Col>
                <Button onClick={onSubmit} disabled={isDisabled}>
                    Submit
                </Button>
            </Col>
            <Modal show={showModal} size="lg" centered onHide={onCancel}>
                <Modal.Header>
                    <h4>Confirm Location Update</h4>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control
                        value={otp}
                        onChange={(e) => onOtpUpdate(e)}
                        // type="number"
                        // disabled={disabled}
                        // isInvalid={!isDurationValid(duration)}
                        placeholder="OTP Code. Ex: 12345678"
                        disabled={disableModal}
                    />
                    A One Time Password Has Been Sent To Your Email.
                    <br />A New Location Will Be Created And Your Account Will Be Updated.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel} disabled={disableModal}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} disabled={disableModal}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
